import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ObjectUtils from "../../../../utils/ObjectUtils";
import SurveyUtils from "../../../../utils/SurveyUtils";

/**
 * Table question component (table head) for survey-view.
 */
const SortableTableQuestionHead = ({ question, onSortRows }) => {
  const [sort, setSort] = useState({});
  const [sortCol, setSortCol] = useState({});

  const handleSort = (identifier, asc) => {
    let tmp = ObjectUtils.deepClone(sort);
    tmp[identifier] = !asc;
    setSort(tmp);
    setSortCol(identifier);
    onSortRows(identifier, asc);
  };

  return (
    <thead>
      <tr>
        <th key="number" className="number" />
        {question.columns &&
          question.columns
            .filter((c) => c.visible !== false)
            .map((column, index) => (
              <th key={index} className={ObjectUtils.toKebabCase(column.type)}>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip" className="survey-tooltip">
                      {column.infoText || column.text}
                      {column.required && " *"}
                    </Tooltip>
                  }
                >
                  <Button
                    variant="link"
                    onClick={() => handleSort(column.name, sort[column.name] ? sort[column.name] : false)}
                  >
                    {column.text}
                    {column.required && " *"}
                  </Button>
                  {column.infoText && <FontAwesomeIcon icon={faInfoCircle} size="xs" className="ms-1" />}
                  {SurveyUtils.sortIcon(column.name, sortCol, sort[column.name] ? sort[column.name] : false)}
                </OverlayTrigger>
              </th>
            ))}
      </tr>
    </thead>
  );
};

SortableTableQuestionHead.propTypes = {
  question: PropTypes.object.isRequired,
  onSortRows: PropTypes.func
};

export default SortableTableQuestionHead;
